<template>
    <div class="page">
      <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm" @keyup.enter.native="refreshList()" @submit.native.prevent>
            <!-- 搜索框-->
         <el-form-item prop="titleEn">
                <el-input size="small" class="width205" v-model="searchForm.titleEn" placeholder="英文标题" clearable></el-input>
         </el-form-item>
         <el-form-item prop="titleCn">
                <el-input size="small" class="width205" v-model="searchForm.titleCn" placeholder="中文标题" clearable></el-input>
         </el-form-item>
         <el-form-item prop="tags">
                <!-- <el-input size="small" class="width205" v-model="searchForm.tags" placeholder="标签" clearable></el-input> -->
                <el-select v-model="searchForm.tagsIdsList" multiple clearable placeholder="标签" class="width205">
                  <el-option
                    v-for="item in tagList"
                    :key="item.id"
                    :label="item.nameEn"
                    :value="item.id">
                  </el-option>
                </el-select>
            </el-form-item>
         <!-- <el-form-item prop="author">
                <el-input size="small" v-model="searchForm.author" placeholder="作者" clearable></el-input>
         </el-form-item> -->
         <el-form-item prop="state">
            <el-select
                v-model="searchForm.state"
                clearable
                placeholder="状态"
                class="width205"
              >
                <el-option
                  v-for="item in stateOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <div class="flex-js-ac">
                        <div class="point" :class="item.value === '0' ? 'greenBack' : item.value === '1' ? 'redBack' : 'yellowBack'"></div>
                        <span>{{ item.label }}</span>
                      </div>
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
            <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
          </el-form-item>
      </el-form>

     <div class="bg-white top">
      <div>
        <span>该模块是News模块下的文章</span>
      </div>
        <vxe-toolbar :refresh="{query: refreshList}" import export print custom>
          <template #buttons>
            <el-button v-if="hasPermission('unmarticle:cecUnmArticle:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button>
            <!-- <el-button v-if="hasPermission('unmarticle:cecUnmArticle:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.cecUnmArticleTable && $refs.cecUnmArticleTable.getCheckboxRecords().length !== 1" plain>修改</el-button> -->
            <el-button v-if="hasPermission('unmarticle:cecUnmArticle:del')" type="danger"   size="small" icon="el-icon-delete" @click="del()" :disabled="$refs.cecUnmArticleTable && $refs.cecUnmArticleTable.getCheckboxRecords().length === 0" plain>删除</el-button>
            <el-dropdown v-if="hasPermission('unmarticle:cecUnmArticle:edit')" class="ml8" :split-button="true" size="small" type="primary" icon="el-icon-files" trigger="click"  @command="handDropDownItem" :disabled="$refs.cecUnmArticleTable && $refs.cecUnmArticleTable.getCheckboxRecords().length === 0" >
              批量操作
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in stateOption" :key="item.value" :command="item.value">
                  <div class="flex-jc-ac">
                    <div class="point" :class="item.value === '0' ? 'greenBack' : item.value === '1' ? 'redBack' : 'yellowBack'"></div>
                    <span>{{ item.label }}</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template #tools>
            <vxe-button
    		  type="default"
    		  title="下载导入模板"
    		  v-if="hasPermission('unmarticle:cecUnmArticle:import')"
    		  class="el-icon-document m-r-12"
    		  @click="downloadTpl()"
    		  circle
            >
            </vxe-button>
          </template>
        </vxe-toolbar>
        <div style="height: calc(100% - 98px);">
        <vxe-table
            border="full"
            auto-resize
            resizable
            height="auto"
            :loading="loading"
            size="small"
            ref="cecUnmArticleTable"
            show-header-overflow
            
            highlight-hover-row
            :menu-config="{}"
            :print-config="{}"
            :import-config="{
            importMethod: importMethod,
                types: ['csv', 'xls', 'xlsx'],
                remote: true,
            }"
            :export-config="{
                remote: true,
                filename: `文章管理数据${moment(new Date()).format(
            		'YYYY-MM-DD'
                )}`,
                sheetName: '文章管理数据',
                exportMethod: exportMethod,
                types: ['xlsx'],
                modes: ['current', 'selected', 'all'],
            }"
            @sort-change="sortChangeHandle"
            :sort-config="{remote:true}"
            :data="dataList"
            :checkbox-config="{}">
            <!-- <vxe-column type="seq" width="40"></vxe-column> -->
            <vxe-column type="checkbox"  width="40px"></vxe-column>
    <vxe-column
        field="sort"
        width="70"
        sortable
        align="center"
        title="排序">
      </vxe-column>
      <vxe-column
        field="state"
        sortable
        align="center"
        width="100"
        title="状态">
        <template slot-scope="scope">
          <!-- {{ scope.row.state === '0' ? '显示' : scope.row.state === '1' ? '禁止' : '草稿' }} -->
          <div class="flex-jc-ac">
            <div class="point" :class="scope.row.state === '0' ? 'greenBack' : scope.row.state === '1' ? 'redBack' : 'yellowBack'"></div>
            <span>{{ scope.row.state === '0' ? '上线' : scope.row.state === '1' ? '下线' : '草稿' }}</span>
          </div>
        </template>
      </vxe-column>
    <vxe-column
        field="titleEn"
        sortable
        show-overflow
        align="center"
        title="英文标题">
        <template slot-scope="scope">
          <div class="textOverflow">
            <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('unmarticle:cecUnmArticle:edit')" @click="edit(scope.row.id)">{{scope.row.titleEn}}</el-link> -->
            <span class="linkSpan" type="primary" :underline="false" v-if="hasPermission('unmarticle:cecUnmArticle:view')"  @click="view(scope.row.id)">{{scope.row.titleEn}}</span>
            <span v-else>{{scope.row.titleEn}}</span>
          </div>
        </template>
      </vxe-column>
      <vxe-column
        field="titleCn"
        show-overflow
        sortable
        align="center"
        title="中文标题">
      </vxe-column>
      <!-- <vxe-column
        field="contentEn"
        align="center"
        title="英文内容值">
        <template slot-scope="scope">
            <p v-html="$utils.unescapeHTML(scope.row.contentEn)"></p>
        </template>
      </vxe-column>
      <vxe-column
        field="contentCn"
        align="center"
        title="中文内容值">
        <template slot-scope="scope">
            <p v-html="$utils.unescapeHTML(scope.row.contentCn)"></p>
        </template>
      </vxe-column> -->
      <vxe-column
        field="tags"
        align="center"
        title="标签">
        <template slot-scope="scope">
          <el-tag
            v-for="(tag ,index) in scope.row.tagsList"
            size="mini"
            :key="index"
            class="singleTag"
            style="margin-right: 5px"
          >{{ tag.nameEn }}</el-tag>
        </template>
      </vxe-column>
      <vxe-column
        field="createDate"
        sortable
        width="150"
        align="center"
        title="创建时间">
      </vxe-column>
      <vxe-column
        field="updateDate"
        sortable
        width="150"
        align="center"
        title="修改时间">
      </vxe-column>
      <vxe-column
        field="author"
        align="center"
        width="100"
        title="作者">
        <template slot-scope="scope">
          {{ scope.row.author ? scope.row.author : '-' }}
        </template>
      </vxe-column>
    <!-- <vxe-column
        field="author"
        sortable
        align="center"
        title="作者">
      </vxe-column> -->
    <!-- <vxe-column
		  field="cover"
      align="center"
		  title="主图">
		  <template  #default="{ row }">
		    <template v-if="row.cover">
          <div class="imageBox">
            <el-image
              style="height: 50px;width:50px;margin-right:10px;"
              :src="setUrlHearder(src)" v-for="(src, index) in row.cover.split(',')" :key="index"
              :preview-src-list="row.cover.split(',')">
            </el-image>
          </div>
		     </template>
		  </template>
		</vxe-column> -->
      <!-- <vxe-column
        fixed="right"
        align="center"
        width="200"
        title="操作">
        <template  slot-scope="scope">
          <el-button v-if="hasPermission('unmarticle:cecUnmArticle:view')" type="text" icon="el-icon-view" size="small" @click="view(scope.row.id)">查看</el-button>
          <el-button v-if="hasPermission('unmarticle:cecUnmArticle:edit')" type="text" icon="el-icon-edit" size="small" @click="edit(scope.row.id)">修改</el-button>
          <el-button v-if="hasPermission('unmarticle:cecUnmArticle:del')" type="text"  icon="el-icon-delete" size="small" @click="del(scope.row.id)">删除</el-button>
        </template>
      </vxe-column> -->
    </vxe-table>
    <vxe-pager
      background
      size="small"
      :current-page="tablePage.currentPage"
      :page-size="tablePage.pageSize"
      :total="tablePage.total"
      :page-sizes="[10, 20, 100, 1000, {label: '全量数据', value: 1000000}]"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="currentChangeHandle">
    </vxe-pager>
    </div>
    </div>
        <!-- 弹窗, 新增 / 修改 -->
    <CecUnmArticleForm  ref="cecUnmArticleForm" @refreshDataList="refreshList" @addTagCloud="getTagCloud"></CecUnmArticleForm>
  </div>
</template>

<script>
  import CecUnmArticleForm from './CecUnmArticleForm'
  import cecUnmArticleService from '@/api/unmarticle/cecUnmArticleService'
  import cecUnmTagCloudService from '@/api/cecunmtagcloud/cecUnmTagCloudService'
  export default {
    data () {
      return {
        searchForm: {
          titleEn: '',
          titleCn: '',
          author: '',
          state: '',
          tagsIdsList: []
        },
        dataList: [],
        tagList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'update_date', asc: false }]
        },
        loading: false,
        stateOption: [
          { value: '0', label: '上线' },
          { value: '2', label: '草稿' },
          { value: '1', label: '下线' }
        ]
      }
    },
    components: {
      CecUnmArticleForm
    },
    activated () {
      this.refreshList()
      this.getTagCloud()
    },
    methods: {
      // 获取标签数据列表
      getTagCloud () {
        cecUnmTagCloudService.list({
          'current': 1,
          'size': 1000,
          'orders': [{ column: 'create_date', asc: false }],
          'associationType': 2
        }).then(({data}) => {
          this.tagList = data.records
        })
      },
      setArry (tags) {
        let tagsList = []
        if (tags) {
          tagsList = tags.split(',')
        }
        return tagsList
      },
      // 拼接url
      setUrlHearder (url) {
        return url.indexOf('http') >= 0 ? url : process.env.VUE_APP_SERVER_URL + url
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        cecUnmArticleService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增
      add () {
        this.$refs.cecUnmArticleForm.init('add', '')
      },
      // 修改
      edit (id) {
        id = id || this.$refs.cecUnmArticleTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.cecUnmArticleForm.init('edit', id)
      },
      // 查看
      view (id) {
        // this.$refs.cecUnmArticleForm.init('view', id)
        this.$router.push({path: '/unmarticle/CecUnmArticleDetail', query: {id: id, type: 'view', title: '文章' + '详情'}})
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.cecUnmArticleTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecUnmArticleService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      handDropDownItem (e) {
        let stateObj = this.stateOption.find(item => item.value === e)
        this.batchOperation(stateObj)
      },
      batchOperation (data) {
        let ids = this.$refs.cecUnmArticleTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        let query = {
          state: data.value,
          idsList: ids
        }
        this.$confirm(`确定${data.label}所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecUnmArticleService.batchOperation(query).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        cecUnmArticleService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        cecUnmArticleService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return cecUnmArticleService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      resetSearch () {
        this.$refs.searchForm.resetFields()
        this.searchForm.tagsIdsList = []
        this.refreshList()
      }
    }
  }
</script>
<style scoped lang="less">
.imageBox{
  width: 100%;
  display: flex;
  justify-content: center;
}
.point{
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 5px;
}
.flex-js-ac{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.flex-jc-ac{
  display: flex;
  align-items: center;
  justify-content: center;
}
.textOverflow{
  overflow: hidden;
  text-overflow: ellipsis;
  .linkSpan {
    cursor: pointer;
    color: #1890FF;
    &:hover {
      text-decoration: underline;
    }
  }
}
.singleTag {
  font-size: 12px;
}
.width205{
  width: 205px;
}
.yellowBack{
  background: radial-gradient(circle, rgb(249, 249, 180), yellow, #7f8131);
}
.greenBack{
  background: radial-gradient(circle, #9fe09f, #40b440, #0c360c);
}
.redBack {
  background: radial-gradient(circle, #db8d92, #e03030, #561f1f);
}
</style>
